import GalleryGrid from './GalleryGrid';

export const Gallery = () => {
  return (
    <>
      <section className="py-24 w-full h-full  ">
        <div className="w-full border-y border-[#FFFF4E] py-4">
          <div className="flex items-center justify-center gap-1 6 w-full">
            <img src={`/static/images/cabo/cabo-sun.png`} alt="" />
            <span className="font-solid-grooves text-center text-4xl text-white ">GALLERY</span>
            <img src={`/static/images/cabo/cabo-sun.png`} alt="" />
          </div>
        </div>
        <div className="container mx-auto pt-10">
          <GalleryGrid />
        </div>
      </section>
    </>
  );
};
